//! =================================================================================
//* Función para abrir el menú lateral cuando el tamaño sea tablet o inferior
//! =================================================================================

export function apertura() {
    
    let menu    = document.getElementById('navPrincipal');
    let estiloMenu = window.getComputedStyle(menu);
    
    if (estiloMenu.width != "0px") {
        
        menu.style.width = '100vw!important';

    } else {
        
        menu.style.width = '0%';
        menu.style.overflow = 'hidden';

    }
    menu.classList.toggle('menu2');    
};   


//! =================================================================================
//* Función para llenar las cards informativas del BLOG de la página principal.
//! =================================================================================
export async function llenarCardsBlog(div_blog) {

    const apiUrl = 'https://www.api.restauni.com/tbblog?&orderBy=fecha&orderMode=DESC&startAt=0&endAt=6&select=idblog,titulo,desc_corta,fecha,imagen_card';

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        // const contenedor = document.getElementById('contenedor-cards-blog');
        const contenedor = div_blog;
        contenedor.innerHTML = ''; // Limpiar el contenido existente

        // console.log(data)

        const cardsBlog = data.results;

        cardsBlog.forEach(item => {
            const cardHtml = `
                <li> 
                    <div class="glb-blog-card"> 
                        <div class="box_image">
                            <a href="noticia.html?id=${item.idblog}">
                                <img src="build/img/blog/${item.imagen_card}" class="img-fluid rounded-top" alt="${item.titulo}" idblog="${item.idblog}">
                            </a>
                        </div>
                        <div class="box_content"> 
                            <div class="box_texto">
                                <a href="noticia.html?id=${item.idblog}" class="text-dark"><h5>${item.titulo}</h5></a>
                                <small>${new Date(item.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })}</small>
                                <p class="text-muted">${item.desc_corta}</p>
                            </div>
                            <div class="box_footer"> 
                                <a href="noticia.html?id=${item.idblog}">Leer más</a>
                            </div>
                        </div>  
                    </div>    
                </li>
            `;
            contenedor.innerHTML += cardHtml;
        });

        $(".slideBlog").jdSlider({
            wrap: '.slide-inner',
            slideShow: 4,
            slideToScroll: 4,
            isLoop: true,
            responsive: [{ 
                viewSize: 576,
                settings: {
                    slideShow: 1,
                    slideToScroll: 1
                }
            },{
                viewSize: 768,
                settings: {
                    slideShow: 2,
                    slideToScroll: 2
                }
            },{
                viewSize: 1024,
                settings: {
                    slideShow: 3,
                    slideToScroll: 3
                }
            }]
        
        });        

    } catch (error) {
        console.error('Error al cargar las tarjetas del blog:', error);
    }
}

//! =================================================================================
//* Función para llenar las cards informativas de la PAGINA del BLOG
//! =================================================================================
export async function llenarPageBlog(page_blog) {

    const apiUrl = 'https://www.api.restauni.com/tbblog?orderBy=fecha&orderMode=DESC&select=idblog,titulo,desc_corta,fecha,imagen_card';

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        // const contenedor = document.getElementById('contenedor-cards-blog');
        const contenedor = page_blog;
        contenedor.innerHTML = ''; // Limpiar el contenido existente

        // console.log(data)

        const cardsBlog = data.results;

        cardsBlog.forEach(item => {
            const cardHtml = `
                <div class="glb-blog-card"> 
                    <div class="box_image">
                        <a href="noticia.html?id=${item.idblog}">
                            <img src="build/img/blog/${item.imagen_card}" class="img-fluid rounded-top" alt="${item.titulo}" idblog="${item.idblog}">
                        </a>
                    </div>
                    <div class="box_content"> 
                        <div class="box_texto">
                            <a href="noticia.html?id=${item.idblog}" class="text-dark"><h5 idblog="${item.idblog}">${item.titulo}</h5></a>
                            <small>${new Date(item.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })}</small>
                            <p class="text-muted">${item.desc_corta}</p>
                        </div>
                        <div class="box_footer"> 
                            <a href="noticia.html?id=${item.idblog}" idblog="${item.idblog}">Leer más</a>
                        </div>
                    </div>  
                </div>    
            `;
            contenedor.innerHTML += cardHtml;
        });

    } catch (error) {
        console.error('Error al cargar las tarjetas del blog:', error);
    }
}


//! =================================================================================
//* Función para cargar y mostrar los detalles de una noticia seleccionada desde el blog
//! =================================================================================

export async function mostrarDetallesBlog(id) {

    const apiUrl = 'https://www.api.restauni.com/tbblog?linkTo=idblog&equalTo=' + id + '&orderBy=fecha&orderMode=DESC&select=idblog,titulo,desc_corta,desc_larga,fecha,imagen_page,video,texto_video,portada_video,link,texto_link';

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        const infoBlog = data.results[0];

        // ! Visualizando la imagen de fondo del servicio

        const fondoHeroServ = document.getElementById('fondoBlog');
        if (fondoHeroServ !== null) {
            fondoHeroServ.innerHTML = `
                <img width="350" height="150" src="build/img/blog/${infoBlog.imagen_page}" alt="${infoBlog.titulo}">
            `;
        }

        // ! Visualizando los datos del encabezado                    
        const secTitulo = document.getElementById('secTituloH1');
        if (secTitulo !== null) {
            secTitulo.innerHTML = `
                <h1>${infoBlog.titulo}</h1>
                <p>${infoBlog.desc_corta}</p>        
                <p class="mt-4"><strong><i class="fas fa-hand-point-down color_rojo"></i> Desliza para conocer más.</strong></p>
            `;
        }

        // ! Visualizando los detalles de la noticia
        const secDetalles = document.getElementById('detalle-noticia');
        if (secDetalles !== null) {

            // Comprueba si texto_link tiene un valor antes de incluir el enlace
            let linkHTML = '';
            if (infoBlog.link) {  // Esto es true si link no es nulo ni una cadena vacía
                linkHTML = `<a href="${infoBlog.link}" target="_blank" class="boton"><i class="fas fa-external-link-square-alt"></i> ${infoBlog.texto_link}</a>`;
            }

            secDetalles.innerHTML = `
                <h2 class="mb-0">${infoBlog.titulo}</h2>
                <small>Fecha: ${new Date(infoBlog.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })}</small>
                <p>${infoBlog.desc_larga.replace(/\n/g, '<br>')}</p>
                ${linkHTML}
            `;
        }

        // ! En caso de que la noticia tenga un vídeo que mostrar, aquí visualizamos el vídeo

        const secVideo = document.getElementById('video-blog');
        
        if (secVideo !== null && infoBlog.video) {
            secVideo.innerHTML = `

                <p>${infoBlog.texto_video}</p>

                <div class="youtube-container">
                    <div class="youtube-video">
                        <iframe class="iframeVideo" src="" title="YouTube video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>

                    <div class="youtube-portada">
                        <picture>
                            <img width="350" height="150" src="build/img/videos/${infoBlog.portada_video}" alt="${infoBlog.titulo}">
                        </picture>
                        <a href="#" class="play" data-embed="${infoBlog.video}"><img width="250" height="250" src="build/img/play.png" alt="Dale PLAY al vídeo" data-embed="${infoBlog.video}"></a>   
                    </div>
                </div>

            `;

            // Asignar evento después de actualizar el DOM
            
            const playButton = secVideo.querySelector('.play');
            playButton.addEventListener('click', function(event) { // Asegúrate de recibir el objeto event aquí
                reproduce_video_youtube(event); // Pasa el evento a la función
            });
                            
        }
        

    } catch (error) {
        console.error('Error al cargar las tarjetas del blog:', error);
    }
}

//! =================================================================================
//* Función para obtener el valor del parámetro "id" desde la URL
//! =================================================================================
export function getParameterByName(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

//! =================================================================================
//* Función para incializar los SLIDERs
//! =================================================================================

export function iniciaSlider() {
    // SLIDER DE LOS MÓDULOS DEL SISTEMA

    $(".slideElements").jdSlider({
        wrap: '.slide-inner',
        slideShow: 4,
        slideToScroll: 4,
        isLoop: true,
        responsive: [{ 
            viewSize: 576,
            settings: {
                slideShow: 1,
                slideToScroll: 1
            }
        },{
            viewSize: 768,
            settings: {
                slideShow: 2,
                slideToScroll: 2
            }
        },{
            viewSize: 1024,
            settings: {
                slideShow: 3,
                slideToScroll: 3
            }
        }]
    
    });        

    $(".slideGallery").jdSlider({
        wrap: '.slide-inner',
        slideShow: 6,
        slideToScroll: 6,
        isLoop: false,
        responsive: [{ 
            viewSize: 576,
            settings: {
                slideShow: 1,
                slideToScroll: 1
            }
        },{
            viewSize: 768,
            settings: {
                slideShow: 2,
                slideToScroll: 2
            }
        },{
            viewSize: 1024,
            settings: {
                slideShow: 3,
                slideToScroll: 3
            }
        }]
    
    });        

    $(".slideReseñas").jdSlider({ 
        wrap: '.slide-inner',
        slideShow: 1,
        isAuto: true,
        isLoop: true
    });        


}

//! =================================================================================
//* Función para cambiar el color de fondo de la barra de menú según la posición de la pantalla
//* Si está en el top, es transparente, si no se le pone un color obscuro
//! =================================================================================

export function navBackground() {

    let nav = document.querySelector('.nav');
    // let desp_actual = window.pageYOffset;
    let desp_actual = window.scrollY;
    let ancho_screen = window.innerWidth;        

    if ( desp_actual <= 300 ) {

        nav.style.borderBottom = ''; 

        if (ancho_screen > 768 ) {
            nav.style.background = 'rgba(0,0,0,0.5)';
        } else {
            nav.style.background = 'linear-gradient(0deg, rgba(0,0,0,0) 5%, rgba(0,0,0,1) 100%)';
        }

    } else {
        nav.style.background = '#1F2022';
        nav.style.borderBottom = '5px solid #cb001a';
    }
    nav.style.transition = '.5s';
    
}

//! =================================================================================
//* Las siguientes funciones sirven para hacer que el fondo del HERO sea dinámico y cambie cada determinados segundos.
//! =================================================================================

export function next_fondo(heros) {
    let idxHero = actBanner(heros, 0);      
    nextBanner(heros, idxHero, '+');        
}

export function actBanner(array, idxBan) {
    while (idxBan < array.length) {
        if (array[idxBan].classList.contains('banner_visible')) {
            break;
        }
        idxBan++;
    }
    return idxBan;
}

export function nextBanner(array, idx, opr) {
    let idxNext = idx;
    if (opr==='+') {
        idxNext++;
        if (idxNext > array.length - 1) {
            idxNext = 0;
        }    
    } else {
        --idxNext;
        if (idxNext < 0) {
            idxNext = array.length - 1;
        }
    }
    array[idx].classList.remove('banner_visible');
    array[idxNext].classList.add('banner_visible');
}

//! =================================================================================
//* Función para marcar las opciones del menú dependiendo de la posición 
//* en la que se encuentre en pantalla
//! =================================================================================

export function updateActiveClass(menuLinks) {
    let found = false;

    // Primero, quitar la clase 'nav_active' de todos los elementos
    menuLinks.forEach(link => link.parentElement.classList.remove('nav_active'));

    // Iterar a través de cada enlace del menú
    for (const link of menuLinks) {
        const sectionId = link.getAttribute('href').substring(1); // Eliminar el '#' del href
        const section = document.getElementById(sectionId);

        if (section) {
            const rect = section.getBoundingClientRect();

            // Comprobar si la sección está en la ventana de visualización
            if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {

                link.parentElement.classList.add('nav_active');
                found = true;

            } else {

                link.parentElement.classList.remove('nav_active');

            }
        }
    }

}

//! =================================================================================
//* Función para llenar el slider de los banners de publicidad
//! =================================================================================

export function llena_bannerspub(div_pub) { 

    let divIndicadores = document.getElementById('div_indicadores');

    div_pub.innerHTML = '';
    divIndicadores.innerHTML = '';

    fetch('https://www.api.restauni.com/tbbannerspub?select=idbanner,descripcion,banner,linkweb')
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al consultar la API de los banners publicitarios. La respuesta no fue OK.');
            }
            return response.json();
        })        
        .then(data => {

            const anuncios = data.results;
            shuffleArray(anuncios); // Mezcla el array antes de procesarlo                
            let i = 0;

            anuncios.forEach(anuncio => {

                // ! Creando los botones de los indicadores del carrusel
                let button = document.createElement("button");
                button.setAttribute("type", "button");
                button.setAttribute("data-bs-target", "#crs_pub");
                button.setAttribute("data-bs-slide-to", i.toString());                    

                const link_anuncio = document.createElement('div');

                link_anuncio.classList.add('carousel-item');
                if (i===0) {
                    button.classList.add("active");                            
                    link_anuncio.classList.add('active');
                }
                i++;

                link_anuncio.innerHTML = ` 
                    <a href="${anuncio.linkweb}" target="_blanck">
                        <picture>                            
                            <img src="https://www.servidorbdk.com/bannerspub/${formatId(anuncio.idbanner)}.jpg" alt="${anuncio.descripcion}" class="d-block fto-img-pub" style="width:100%">
                        </picture>                            
                    </a>
                `;

                // Agrega la anuncio al contenedor 
                divIndicadores.appendChild(button);                       
                div_pub.appendChild(link_anuncio);

            });
        })
    .catch(error => {
        console.error('Error al obtener los datos del archivo JSON:', error);
    });                      

}

//! =================================================================================
//* Función para ordenar aleatoriamente un arreglo
//! =================================================================================

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i
        [array[i], array[j]] = [array[j], array[i]]; // swap elements
    }
}

//! =================================================================================
//* Función que regresa el valor en STRING de 2 digitos, para cuando el valor es menor a 10, regresa 01,02,etc
//! =================================================================================

function formatId(id) {
    return id < 10 ? `0${id}` : id.toString();
}

//! =================================================================================
//* Función para visualizar los mensajes informativos en la barra de color después del HERO
//! =================================================================================

export function updateMessage(messages, titleElement, descriptionElement, indicators, containerElement, currentIndex) {

    titleElement.textContent = messages[currentIndex].title;
    descriptionElement.textContent = messages[currentIndex].description;
    indicators.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === currentIndex);
    });
    containerElement.style.opacity = 1;
    setTimeout(() => {
        containerElement.style.opacity = 0;
        let nextIndex = (currentIndex + 1) % messages.length;
        setTimeout(() => {
            updateMessage(messages, titleElement, descriptionElement, indicators, containerElement, nextIndex);
        }, 1000); // Time to fade out before updating to the next message
    }, 1500);
}

export function cycleMessages(messages, titleElement, descriptionElement, indicators, containerElement, currentIndex) {
    setTimeout(() => {
        updateMessage(messages, titleElement, descriptionElement, indicators, containerElement, currentIndex);
    }, 2500);
}

//! =================================================================================
//* Función para reproducir vídeos de Youtube directamente en la página
//! =================================================================================

export function reproduce_video_youtube(event) {

    event.preventDefault(); // Previene que el enlace se abra directamente

    const obj = event.currentTarget; // El elemento que recibió el clic
    const container = obj.closest('.youtube-container'); // Encuentra el contenedor principal

    const iframeElement = container.querySelector(".youtube-video iframe"); // Encuentra el iframe dentro del contenedor
    iframeElement.src = ""; // Limpia el src para asegurar que el video se detiene si estaba jugando

    const portadaElement = container.querySelector('.youtube-portada'); // Encuentra el contenedor de la portada
    if (portadaElement) {
        portadaElement.remove(); // Elimina la portada si existe
    }

    // Configura la nueva URL del iframe con autoplay
    iframeElement.setAttribute("src", "https://www.youtube.com/embed/"+obj.dataset.embed+"?autoplay=1" );  // Autoplay y mute

}

//! =================================================================================
//* Functión para reproducir un vídeo en una ventana popup
//! =================================================================================

export function reproduce_video_popup( obj ) {

    const videoId = $(obj).data('embed'); // Obtiene el ID del video directamente del atributo data-embed
    const iframeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    // Verifica si los elementos existen antes de intentar usarlos
    if ($('#ventanaVideo').length && $('#iframeVideo').length) {
        $('#iframeVideo').attr('src', iframeUrl);
        $('#ventanaVideo').modal('show');
    } else {
        console.error('Los elementos necesarios no están en esta página.');
    }

}

//! =================================================================================
// * Función para obtener y mostrar los cursos de un nivel específico
//! =================================================================================

export async function cursosNivel() {

    try {
        // URL de la API con el parámetro del nivel
        const apiUrl = `https://www.api.restauni.com/tbcursos?linkTo=&equalTo=&orderBy=numestatus&orderMode=ASC&select=idcurso,nomcurso,numestatus,estatus,desc_corta,card,enlapagina,nivel,curgratis`;
        // const apiUrl = `https://www.api.restauni.com/tbcursos?linkTo=nivel&equalTo=${nivel}&orderBy=numestatus&orderMode=ASC&select=idcurso,nomcurso,numestatus,estatus,desc_corta,card,enlapagina`;
        
        // Realizar la solicitud fetch a la API
        const response = await fetch(apiUrl);
        const data = await response.json();

        // Contenedor donde se mostrarán las cards
        const contenedorCursos = document.querySelector('.cursos-container');

        // Limpiar el contenedor antes de añadir las nuevas cards
        contenedorCursos.innerHTML = '';

        // Verificar si la API devolvió resultados
        if (data.status === 200 && data.results.length > 0) {
            const cursos = data.results;

            // Generar las cards dinámicamente
            cursos.forEach(curso => {

                if (curso.nivel === 5) {
                    return; // Salta esta iteración y pasa a la siguiente
                }                

                // Determinar la clase y el texto del estatus basado en numestatus
                let claseEstatus = '';
                let textoEstatus = '';

                switch (curso.numestatus) {
                    case 1:
                        claseEstatus = 'disponible';
                        textoEstatus = 'Disponible';
                        break;
                    case 2:
                        claseEstatus = 'suscripcion';
                        textoEstatus = 'Disponible en Modo Suscripción';
                        break;
                    case 3:
                        claseEstatus = 'ebook';
                        textoEstatus = 'Disponible en E-BOOK';
                        break;
                    case 4:
                        claseEstatus = 'inactivo';
                        textoEstatus = 'En Producción';
                        break;
                    default:
                        claseEstatus = 'inactivo';
                        textoEstatus = 'Sin Información';
                }

                // Verificar si el curso está en la página
                const claseGrayscale = curso.enlapagina === 0 ? 'glbGrayscale' : '';

                let etiquetaGratis = '';

                if (curso.curgratis == 1) {
                    etiquetaGratis = '<span class="cursoGratis disponible">Curso Gratis</span>';
                }

                // Crear la estructura HTML de la card
                const cardHTML = `
                    <div class="curso-card">
                        <div class="card-img ${claseGrayscale}">
                            <picture>  
                                <source srcset="build/img/cursos/${curso.card.replace('.jpg', '.avif')}" type="image/avif">
                                <source srcset="build/img/cursos/${curso.card.replace('.jpg', '.webp')}" type="image/webp">
                                <img src="build/img/cursos/${curso.card}" alt="${curso.nomcurso}">
                            </picture>
                            <span class="status ${claseEstatus}">${textoEstatus}</span>
                            ${etiquetaGratis}
                        </div>
                        <div class="card-content">
                            <a href="detallecurso.html?idc=${curso.idcurso}"><h4>${curso.nomcurso}</h4></a>
                            <p>${curso.desc_corta}</p>
                            <a href="detallecurso.html?idc=${curso.idcurso}" class="btn-view">Ver Curso</a>
                        </div>
                    </div>
                `;

                // Insertar la card en el contenedor
                contenedorCursos.innerHTML += cardHTML;

            });

            // Cambiando el DISPLAY para que las tarjetas salgan centradas cuando son menos de 4
            if (contenedorCursos.children.length < 4) {
                contenedorCursos.classList.add('few-items');
            } else {
                contenedorCursos.classList.remove('few-items');
            }                

        } else {
            // Si no hay resultados, mostrar un mensaje
            contenedorCursos.innerHTML = '<p>No hay cursos disponibles para este nivel.</p>';
        }

    } catch (error) {
        console.error('Error al obtener los cursos:', error);
        contenedorCursos.innerHTML = '<p>Error al cargar los cursos.</p>';
    }
}

//! =================================================================================
//* Función para cargar y mostrar los detalles de un curso seleccionado
//! =================================================================================

export async function mostrarCurso(id) {


    const apiUrl = 'https://www.api.restauni.com/tbcursos?linkTo=idcurso&equalTo=' + id + '&select=*';
    
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        const infoCurso = data.results[0];

        // ! Visualizando la imagen de fondo del servicio

        const fondoHero = document.getElementById('fondoCurso');
        if (fondoHero !== null) {
            fondoHero.innerHTML = `
                <img width="350" height="150" src="build/img/cursos/${infoCurso.pagina}" alt="$infoCurso.nomcurso">
            `;

            if (infoCurso.enlapagina === 1) {
                fondoHero.classList.add('filtro-negro');
            } else {
                fondoHero.classList.add('filtro-gris');          
            }

            const bandaNoDisp = document.getElementById('banda-nodisponible')
            if (infoCurso.numestatus === 4) {    
                bandaNoDisp.classList.remove('no-mostrar');

                const comprarCurso = document.getElementById('comprar-curso');
                comprarCurso.classList.add('no-mostrar');
            }

            const bandaGratis = document.getElementById('banda-gratis')
            if (infoCurso.curgratis === 1) {    
                bandaGratis.classList.remove('no-mostrar');
            }

        }


        // ! Visualizando los datos del encabezado                    
        const secTitulo = document.getElementById('secTituloH1');
        if (secTitulo !== null) {

            secTitulo.innerHTML = `
                <h1>${infoCurso.nomcurso.replace(/:/g, '<br>')}</h1>
                <p>${infoCurso.desc_corta.replace(/\. /g, '.<br>')}</p>
            `;            

        }

        // ! Verificando la disponibilidad del curso
        const secBandaSuscrip = document.getElementById('banda-suscripcion');        
        if (infoCurso.numestatus === 2) {
            secBandaSuscrip.classList.remove('no-mostrar');
            console.log(infoCurso);            
        }
    

        // ! Visualizando los detalles del curso
        const secDetalles = document.getElementById('detalle-curso');
        if (secDetalles !== null) {

            // Asumiendo que infoCurso.desc_larga contiene el texto desde la API
            let descLargaFormateada = infoCurso.desc_larga
                .replace(/\n/g, '<br>')  // Reemplaza los saltos de línea con <br>
                .replace(/(\*\*(.*?)\*\*)/g, '<strong>$2</strong>');  // Formato de negritas (opcional si quieres usar algún marcador)

            secDetalles.innerHTML = `
                <p>${descLargaFormateada}</p>
            `;
        
        }

        // ! En caso de que el curso tenga un vídeo que mostrar, aquí visualizamos el vídeo

        const secVideo = document.getElementById('video-curso');
        
        if (secVideo !== null && infoCurso.video) {
            secVideo.innerHTML = `

                <div class="youtube-container">
                    <div class="youtube-video">
                        <iframe class="iframeVideo" src="" title="YouTube video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>

                    <div class="youtube-portada">
                        <picture>
                            <img width="350" height="150" src="build/img/cursos/${infoCurso.portada_video}" alt="${infoCurso.nomcurso}">
                        </picture>
                        <a href="#" class="play" data-embed="${infoCurso.video}"><img width="250" height="250" src="build/img/play.png" alt="Dale PLAY al vídeo" data-embed="${infoCurso.video}"></a>   
                    </div>
                </div>

            `;

            // Asignar evento después de actualizar el DOM
            
            const playButton = secVideo.querySelector('.play');
            playButton.addEventListener('click', function(event) { // Asegúrate de recibir el objeto event aquí
                reproduce_video_youtube(event); // Pasa el evento a la función
            });
        }

        // ! OBTENIENDO LOS PRECIOS DEL CURSO EN VÍDEO Y EN E-BOOK

        const precioCurso = document.getElementById('precio-curso');
        const urlCurso = document.getElementById('url-curso');

        const precioEbook = document.getElementById('precio-ebook');
        const urlEbook = document.getElementById('url-ebook');

        const precioCombo = document.getElementById('precio-combo');
        const urlCombo = document.getElementById('url-combo');

        const precioFtdCurso = infoCurso.curso_precio.toFixed(2);
        precioCurso.textContent = `$ ${precioFtdCurso} USD`;
        urlCurso.href = infoCurso.curso_url;

        const precioFtdEbook = infoCurso.ebook_precio.toFixed(2);
        precioEbook.textContent = `$ ${precioFtdEbook} USD`;
        urlEbook.href = infoCurso.ebook_url;

        const precioFtdCombo = infoCurso.combo_precio.toFixed(2);
        precioCombo.textContent = `$ ${precioFtdCombo} USD`;
        urlCombo.href = infoCurso.combo_url;

        const urlSuscripcion = document.getElementById('url-suscripcion');


        // ! OBTENIENDO EL PRECIO DE LA SUSCRIPCIÓN

        const apiUrlSuscripcion = 'https://www.api.restauni.com/tbconfiguraciones';

        try {
            const response2 = await fetch(apiUrlSuscripcion);
            
            if (!response2.ok) {
                throw new Error(`HTTP error! status: ${response2.status}`);
            }
            
            const data2 = await response2.json();
            const infoSuscripcion = data2.results[0]; // Aquí se obtiene el primer resultado
    
            const precioSuscripcion = document.getElementById('precio-suscripcion');
            
            if (precioSuscripcion !== null) {
                // Aseguramos que el precio es un número y lo formateamos
                const precioFormateado = infoSuscripcion.precio.toFixed(2);
                precioSuscripcion.textContent = `$ ${precioFormateado} USD`;

                urlSuscripcion.href = infoSuscripcion.url;

            } else {
                console.error('No se encontró el elemento con ID "precio-suscripcion".');
            }
    
        } catch (error) {
            console.error('Error al cargar el precio de la suscripción:', error);
        }        

        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        // * HABILITANDO BOTONES PARA COMPRAR LOS PAQUETES DISPONIBLES
        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

        if (infoCurso.disvideo !== 1) {

            urlCurso.setAttribute("href", "#");

            urlCurso.classList.remove("boton");
            urlCurso.classList.add("botonGris");

            urlCurso.textContent = "PRÓXIMAMENTE";
        }

        if (infoCurso.dissuscripcion !== 1) {

            urlSuscripcion.setAttribute("href", "#");

            urlSuscripcion.classList.remove("boton");
            urlSuscripcion.classList.add("botonGris");

            urlSuscripcion.textContent = "PRÓXIMAMENTE";
        }

        if (infoCurso.disebook !== 1) {

            urlEbook.setAttribute("href", "#");

            urlEbook.classList.remove("boton");
            urlEbook.classList.add("botonGris");

            urlEbook.textContent = "PRÓXIMAMENTE";
        }

        if (infoCurso.discombo !== 1) {

            urlCombo.setAttribute("href", "#");

            urlCombo.classList.remove("boton");
            urlCombo.classList.add("botonGris");

            urlCombo.textContent = "PRÓXIMAMENTE";
        }

        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        // * VERIFICANDO SI EXISTE ALGÚN CUPÓN DE DESCUENTO ACTIVO
        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

        const apiUrlCupon = 'https://www.api.restauni.com/tbcupones?linkTo=activo&equalTo=1&select=*';

        try {
            const response3 = await fetch(apiUrlCupon);
            
            if (!response3.ok) {
                throw new Error(`HTTP error! status: ${response3.status}`);
            }
            
            const data3 = await response3.json();
            const infoCupon = data3.results[0]; // Aquí se obtiene el primer resultado
    
            const divCupon = document.getElementById('cupon-activo');
            
            if (divCupon !== null) {

                divCupon.classList.remove('no-mostrar');

                // let textoFormateado = infoCupon.textocupon
                // .replace(/\n/g, '<br>')  // Reemplaza los saltos de línea con <br>
                // .replace(/(\*\*(.*?)\*\*)/g, '<strong>$2</strong>');  // Formato de negritas (opcional si quieres usar algún marcador)

                const textoCupon = divCupon.querySelector('.texto-cupon');
                if (textoCupon) {

                    let textoFormateado = infoCupon.textocupon.replace(/\n/g, '<br>'); // Reemplaza los saltos de línea con <br>
                    textoCupon.innerHTML = textoFormateado;
        
                } else {
                    console.error('No se encontró el elemento con la clase "texto-cupon".');
                }                

            } else {

                console.error('No se encontró el elemento con ID "cupon-activo".');

            }
    
        } catch (error) {
            console.error('Error al cargar el cupon de descuento:', error);
        }        

        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        // * CARGANDO LAS LECCIONES DEL CURSO SELECCIONADO
        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

        const apiUrlLecciones = `https://www.api.restauni.com/tblecciones?linkTo=idcurso&equalTo=${id}&orderBy=idleccion&orderMode=ASC`;

        const tbody = document.getElementById('lista-lecciones');

        try {
            const response = await fetch(apiUrlLecciones);
            const dataLecciones = await response.json();

            if (dataLecciones.status === 200) {
                const lecciones = dataLecciones.results;

                // Limpiar el contenido previo del tbody
                tbody.innerHTML = '';

                // Recorrer y cargar las lecciones en la tabla
                lecciones.forEach(leccion => {

                    const fila = document.createElement('tr');

                    // Columna Nombre de la Lección
                    const nombreLeccion = document.createElement('td');
                    nombreLeccion.textContent = leccion.nomleccion;
                    fila.appendChild(nombreLeccion);

                    // Columna Estatus de la Lección
                    const estatusLeccion = document.createElement('td');
                    const estatusTexto = document.createElement('p');
                    estatusTexto.classList.add('estatus');

                    if (leccion.estatus === 1) {

                        estatusTexto.textContent = 'Disponible';
                        estatusTexto.classList.add('disponible');

                    } else if (leccion.estatus === 0) {

                        estatusTexto.textContent = 'En Producción';
                        estatusTexto.classList.add('no-disponible');

                    }

                    estatusLeccion.appendChild(estatusTexto);
                    fila.appendChild(estatusLeccion);

                    // Columna para el botón PLAY
                    const accionLeccion = document.createElement('td');

                    if (leccion.video !== null) {

                        const botonPlay = document.createElement('button');
                        botonPlay.classList.add('btn-play');
                        botonPlay.setAttribute('data-bs-toggle', 'modal');
                        botonPlay.setAttribute('data-bs-target', '#ventanaVideo');
                        botonPlay.setAttribute('data-video', leccion.video);
                        botonPlay.textContent = 'Play';

                        // Agregar el botón a la columna
                        accionLeccion.appendChild(botonPlay);

                    }

                    fila.appendChild(accionLeccion);

                    // Agregar la fila completa al tbody
                    tbody.appendChild(fila);

                });
            }

            // Evento para reproducir el video en el modal
            document.querySelector('#ventanaVideo').addEventListener('show.bs.modal', function (event) {

                const button = event.relatedTarget;
                const videoUrl = button.getAttribute('data-video');

                const iframeUrl = `https://www.youtube.com/embed/${videoUrl}?autoplay=1`;
    
                $('#iframeVideo').attr('src', iframeUrl);

            });



            // // Limpiar el src del iframe cuando se cierra el modal
            document.querySelector('#ventanaVideo').addEventListener('hidden.bs.modal', function () {
                document.getElementById('iframeVideo').src = '';
            });
            

        
            // Verifica si los elementos existen antes de intentar usarlos
            // if ($('#ventanaVideo').length && $('#iframeVideo').length) {
            //     $('#iframeVideo').attr('src', iframeUrl);
            //     $('#ventanaVideo').modal('show');
            // } else {
            //     console.error('Los elementos necesarios no están en esta página.');
            // }
        



        } catch (error) {
            console.error('Error al cargar las lecciones:', error);
        }        

        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        // * CREANDO EL ESQUEMA DE GOOGLE SEO DINAMICAMENTE
        // ! - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

        agregarJsonLD(infoCurso)


    } catch (error) {
        console.error('Error al carcar el contenido del curso:', error);
    }
}


//! =================================================================================
//* Función para agergar el código necesario para Google Search Console
//! =================================================================================

function agregarJsonLD(curso) {
    const jsonLd = {
        "@context": "https://schema.org", 
        "@type": "Course",
        "name": curso.nomcurso,
        "description": curso.desc_corta,
        "image": "https://www.restauni.com/build/img/cursos/" + curso.card,
        "brand": {
            "@type": "Brand",
            "name": "RESTAUNI"
        },
        "offers": {
            "@type": "Offer",
            "url": "https://www.restauni.com/detallecurso.html?idc=" + curso.idcurso,
            "priceCurrency": "USD",
            "price": curso.curso_precio.toFixed(2),
            "availability": "https://schema.org/InStock",
            "category": "Education",
            "itemCondition": "https://schema.org/NewCondition"
        },
        "hasCourseInstance": {
            "@type": "CourseInstance",
            "name": curso.nomcurso,
            "description": curso.desc_corta || "Detalles del curso no disponibles.",
            "courseMode": "Online",
            "courseWorkload": "PT10H"
        }
    };

    // Crear y agregar el script JSON-LD al DOM
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
}

//! =================================================================================
//* Función para enviar los eventos a META ADS mediante la API de Conversiones
//! =================================================================================

export async function registrarEventoEnLaApiMetaAds(eventName, email, phone, name) {

    const url = "https://www.restauni.com/api_conversiones/send_event.php";

    const fbc = getCookieValue('_fbc') || null; 
    const fbp = getCookieValue('_fbp') || null;

    // Intentamos obtener el eventID del Píxel (si Meta lo asignó)
    let eventID = window.fbq && window.fbq.getEventId ? window.fbq.getEventId() : "event_" + Date.now();    

    console.log(`Registrando evento: ${eventName}`, {
        name,
        email,
        phone,
        fbc,
        fbp
    });
    
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Allow-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
            event_name: eventName,
            event_id: eventID, // Ahora enviamos el mismo event_id del Píxel si existe            
            ...(name && { name: name }), // Agrega name si está disponible            
            ...(email && { email: email }), // Agrega email si está disponible
            ...(phone && { phone: phone }), // Agrega phone si está disponible
            ...(fbc && { fbc: fbc }), // Agrega fbc si está disponible
            ...(fbp && { fbp: fbp }) // Agrega fbp si está disponible

        }),        
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
    })
    .then(data => {
        console.log(`Evento "${eventName}" enviado con éxito:`, data);
    })
    .catch(error => {
        console.error(`Error al enviar el evento "${eventName}":`, error.message);
    });
}


//! =================================================================================
//* Función para capturar el valor de la cookie, para que la API de conversiones
//* pueda detectar el click
//! =================================================================================

function getCookieValue(cookieName) {

    const cookies = document.cookie.split('; ');

    for (let cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
            return value;
        }
    }
    return null;

}

//! =================================================================================
//* Función para optimizar la carga del evento SCROLL, es una optimización para no cargar tantos recursos 
//* al momento de estar ejecutando el evento SCROLL
//! =================================================================================

export function throttle(callback, limit) {
    let waiting = false; 
    return function () {
        if (!waiting) {
            callback.apply(this, arguments);
            waiting = true;
            setTimeout(() => waiting = false, limit);
        }
    };
}

//! =================================================================================
//* Función para llenar las cards informativas de los patrocinadores
//! =================================================================================
export async function llenarPagePatros(page) {

    // const apiUrl = 'https://www.api.restauni.com/tbblog?orderBy=fecha&orderMode=DESC&startAt=0&endAt=6&select=idblog,titulo,desc_corta,fecha,imagen_card';
    const apiUrl = 'https://www.api.restauni.com/tbpatrocinadores?orderBy=exclusivo&orderMode=DESC&select=idpatro,titulo,desc_corta,region,imagen_card';

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        const contenedor = page;
        contenedor.innerHTML = ''; // Limpiar el contenido existente

        // console.log(data)

        const cards = data.results;

        cards.forEach(item => {
            const cardHtml = `
                <div class="glb-blog-card"> 
                    <div class="box_image">
                        <a href="patrocinador.html?idp=${item.idpatro}">
                            <img src="build/img/patrocinadores/${item.imagen_card}" class="img-fluid rounded-top" alt="${item.titulo}" idpatro="${item.idpatro}">
                        </a>
                    </div>
                    <div class="box_content"> 
                        <div class="box_texto">
                            <a href="patrocinador.html?idp=${item.idpatro}" class="text-dark"><h5 idpatro="${item.idpatro}">${item.titulo}</h5></a>
                            <small>${item.region}</small>
                            <p class="text-muted">${item.desc_corta}</p>
                        </div>
                        <div class="box_footer"> 
                            <a href="patrocinador.html?idp=${item.idpatro}" idpatro="${item.idpatro}"><i class="fas fa-hand-point-right"></i> Ver Detalles</a>
                        </div>
                    </div>  
                </div>    
            `;
            contenedor.innerHTML += cardHtml;
        });

    } catch (error) {
        console.error('Error al cargar las tarjetas de los patrocinadores:', error);
    }
}

//! =================================================================================
//* Función para cargar y mostrar los detalles de un patrocinador
//! =================================================================================

export async function mostrarDetallesPatro(id) {

    const apiUrl = 'https://www.api.restauni.com/tbpatrocinadores?linkTo=idpatro&equalTo=' + id + '&select=idpatro,titulo,desc_corta,desc_larga,region,exclusivo,imagen_page,video,texto_video,portada_video,link,texto_link';

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        const infoPatro = data.results[0];

        // ! Visualizando la imagen de fondo del servicio

        const fondoHeroServ = document.getElementById('fondoPatros');
        if (fondoHeroServ !== null) {
            fondoHeroServ.innerHTML = `
                <img width="350" height="150" src="build/img/patrocinadores/${infoPatro.imagen_page}" alt="${infoPatro.titulo}">
            `;
        }

        // ! Visualizando los datos del encabezado                    
        const secTitulo = document.getElementById('secTituloH1');
        if (secTitulo !== null) {
            secTitulo.innerHTML = `
                <h1>${infoPatro.titulo}</h1>
                <p>${infoPatro.desc_corta}</p>        
                <p class="mt-4"><strong><i class="fas fa-hand-point-down color_rojo"></i> Desliza para conocer más.</strong></p>
            `;
        }

        // ! Visualizando los detalles o descripción larga
        const secDetalles = document.getElementById('detalle-patros');
        if (secDetalles !== null) {

            // Comprueba si texto_link tiene un valor antes de incluir el enlace
            let linkHTML = '';
            if (infoPatro.link) {  // Esto es true si link no es nulo ni una cadena vacía
                linkHTML = `<a href="${infoPatro.link}" target="_blank" class="boton mt-5"><i class="fas fa-external-link-square-alt"></i> ${infoPatro.texto_link}</a>`;
            }

            secDetalles.innerHTML = `
                <h2 class="mb-0">${infoPatro.titulo}</h2>
                <p class="region"><i class="fas fa-map-marker-alt"></i> ${infoPatro.region}</p>
                <p>${infoPatro.desc_larga.replace(/\n/g, '<br>')}</p>
                ${linkHTML}
            `;
        }

        // ! En caso de que la noticia tenga un vídeo que mostrar, aquí visualizamos el vídeo

        const secVideo = document.getElementById('video-patros');
        
        if (secVideo !== null && infoPatro.video) {

            secVideo.innerHTML = `

                <div class="youtube-container">
                    <div class="youtube-video">
                        <iframe class="iframeVideo" src="" title="YouTube video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>

                    <div class="youtube-portada">
                        <picture>
                            <img width="350" height="150" src="build/img/videos/${infoPatro.portada_video}" alt="${infoPatro.titulo}">
                        </picture>
                        <a href="#" class="play" data-embed="${infoPatro.video}"><img width="250" height="250" src="build/img/play.png" alt="Dale PLAY al vídeo" data-embed="${infoPatro.video}"></a>   
                    </div>
                </div>

                <p>${infoPatro.texto_video}</p>                
            `;

            // Asignar evento después de actualizar el DOM
            
            const playButton = secVideo.querySelector('.play');
            playButton.addEventListener('click', function(event) { // Asegúrate de recibir el objeto event aquí
                reproduce_video_youtube(event); // Pasa el evento a la función
            });
                            
        }
        

    } catch (error) {
        console.error('Error al cargar las tarjetas del blog:', error);
    }
}
